import { AxiosResponse } from 'axios';

import {
  LoginResponseType,
  NewPasswordRequestType,
  RestorePasswordResponseType,
  SendCodeRequestType,
  SignUpRequestType,
  CommonResponseType,
} from './types';

import { authServiceClient } from 'config';

export const logInRequest = (email: string, password: string) => {
  const data = {
    email,
    password,
  };

  return authServiceClient.post<
    LoginResponseType,
    AxiosResponse<LoginResponseType>,
    { email: string; password: string }
  >(`/auth/sign-in`, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const signUpRequest = (data: SignUpRequestType) => {
  return authServiceClient.post<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    SignUpRequestType
  >(`/auth/sign-up`, data);
};

export const restorePasswordRequest = (email: string) => {
  return authServiceClient.post<
    RestorePasswordResponseType,
    AxiosResponse<RestorePasswordResponseType>,
    { email: string }
  >(`/auth/restore-password`, { email });
};

export const sendConfirmationCode = (token: string, code: string) => {
  return authServiceClient.post<
    RestorePasswordResponseType,
    AxiosResponse<RestorePasswordResponseType>,
    SendCodeRequestType
  >(`/auth/verify-reset`, { token, code });
};

export const changePassword = (params: NewPasswordRequestType) => {
  return authServiceClient.post<
    RestorePasswordResponseType,
    AxiosResponse<RestorePasswordResponseType>,
    NewPasswordRequestType
  >(`/auth/change-password`, params);
};

export const resendConfirmationCode = (token: string) => {
  return authServiceClient.post<
    RestorePasswordResponseType,
    AxiosResponse<RestorePasswordResponseType>,
    { token: string }
  >(`/auth/resend-reset-code`, { token });
};

export const refreshTokenRequest = (token: string) => {
  return authServiceClient.get<
    { accessToken: string },
    AxiosResponse<{ accessToken: string }>,
    { token: string }
  >(`/auth/refresh`, { headers: { refresh: token } });
};
